<template>
	<v-card hover class="product-card">
		<v-layout class="ma-0 product-card__container">
			<v-flex class="product-card__image pa-0">
				<v-img
					height="100%"
					:src="getObjectValue('photo_url', product)"
					contain
					:style="
						product.part_family.slug === 'nutting-carts-trailers'
							? 'background-color: #FFFFFF;'
							: 'background-color: #00529c;'
					"
				></v-img>
			</v-flex>
			<v-flex class="product-card__content pa-0">
				<v-card-title primary-title>
					<div>
						<h4 class="title mb-1 grey--text">
							{{ product.part_family.name }}
						</h4>
						<h4 class="title mb-2 grey--text">
							#{{ product.display_sku }}
						</h4>
						<h3 class="headline font-weight-bold mb-0">
							{{ product.name }}
						</h3>
						<h4
							class="title mb-2 grey--text"
							v-for="(summaryLine, index) in product.summary"
							:key="index"
						>
							{{ summaryLine }}
						</h4>
					</div>
				</v-card-title>
				<v-card-text class="py-0">
					<ul class="product-card__attributes attributes-list">
						<template v-for="attribute in product.attributes">
							<v-tooltip
								top
								nudge-left="100%"
								:key="attribute.id"
								v-if="icons[attribute.slug]"
							>
								<template v-slot:activator="{ on }">
									<li v-on="on">
										<div class="v-icon v-icon--left">
											<fa-icon
												:icon="icons[attribute.slug]"
												size="xs"
												fixed-width
											/>
										</div>
										<span>
											{{ attribute.value }}
											<span
												v-if="
													attribute.units &&
														attribute.name !=
															'Lifting Capacity'
												"
												>({{ attribute.units }})</span
											>
											<span
												v-if="
													attribute.units &&
														attribute.name ==
															'Lifting Capacity'
												"
												v-text="
													parseFloat(
														attribute.value
													) > 1
														? attribute.units
														: attribute.units_singular
												"
												style="text-transform: capitalize;"
											></span>
										</span>
									</li>
								</template>
								<span>{{ attribute.name }}</span>
							</v-tooltip>
						</template>
					</ul>
				</v-card-text>
				<v-card-actions class="pa-3 product-card__actions">
					<v-spacer></v-spacer>
					<v-btn color="primary" large @click="selectProduct"
						>Select</v-btn
					>
				</v-card-actions>
			</v-flex>
		</v-layout>
	</v-card>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	data() {
		return {
			icons: {
				capacity: ["far", "weight-hanging"],
				headroom: ["far", "hard-hat"],
				"hoist-lift-fixed": ["far", "ruler-vertical"],
				"lifting-capacity": ["far", "weight-hanging"],
				"lifting-speed": ["far", "tachometer-alt"],
				"min-max-beam-width": ["far", "ruler-horizontal"],
				"min-beam-radius": ["fas", "adjust"],
				"power-supply": ["far", "bolt"],
				"suspension-type": ["fac", "pulley"],
				"traversing-speed": ["far", "tachometer-alt"],
				"traversing-speed-fpm": ["far", "tachometer-alt"],
				"max-truck-load-lb": ["far", "weight-hanging"]
			}
		};
	},

	props: {
		product: {
			default: false
		}
	},

	computed: {},

	methods: {
		...mapMutations(["SET_VALUE"]),

		selectProduct() {
			this.SET_VALUE({
				name: "products.selectedProduct",
				value: this.product
			});

			this.$emit("select-product", this.product.sku);
		}
	}
};
</script>
